/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TypeIpGs {
  Melli = 1,
  Mellat = 2,
  AsanPardakht = 3,
  Pasargad = 4,
  Saman = 5,
  Sepehr = 6,
  IranKish = 7,
  Parsian = 8,
  ZarinPal = 9,
  PayIr = 10,
  IdPay = 11,
  ParbadVirtual = 12
}
